



































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Client} from "@/core/services/MedicaPro/models";
import MeasurementListCreateNew
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-CreateNew.vue";
import {Api} from "@/core/services/MedicaPro/Api";
import {Filter} from "@/components/Admin/Clients/Details/Components/MeasurementList/Helpers/Filter";

@Component({
    components: {
        MeasurementListCreateNew

    }
})
export default class MeasurementListToolbar extends BaseComponent {

    // Bindings to parent
    @Prop() client!: Client;
    @Prop() filter!: Filter;
    @Prop() category?: string;

    // Bindings to view
    public isReady = false;
    public availableIdentifiers: { name: string, value: string }[] = [];
    public selectedIdentifiers: string[] = [];

    public mounted() {
        this.renderView();

        this.subscribe(this.filter.onChange.subscribe(() => {
            this.selectedIdentifiers = this.filter.getIdentifiers() ?? [];
        }));
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.isReady = true;

        Api.measurementTypes().identifiersGetGet()
            .category(this.category ?? 'all')
            .find((values: string[]) => {
                this.availableIdentifiers = values.map(value => {
                    return {
                        name: this.$t(`measurement-identifiers.${value}`) as string,
                        value: value
                    }
                });
                this.selectedIdentifiers = this.filter.getIdentifiers() ?? [];
            });
    }

    public onSelectedIdentifiersChange() {
        this.filter.setIdentifiers(this.selectedIdentifiers.length ? this.selectedIdentifiers : undefined, true);
    }

}
